"use client";

import { handleCheckoutSession } from "@/app/utils/checkout-session";
import { DISCOUNT_ID, PRICING_ID_T1, PRICING_NAME_T1 } from "@/lib/constants";
import { motion } from "motion/react";

const waitlist_id = 26456;

function CTA() {
  return (
    <div id="cta" className={`bg-ink w-full`}>
      <div className="w-full xl:w-[1250px] px-6 mx-auto flex justify-center items-center py-24">
        <motion.div
          className={`card relative overflow-hidden bg-panel border border-line shadow-2xl shadow-black/40 text-white w-full xl:w-[1250px] mx-auto`}
        >
          {/* atmosphere */}
          <div className="pointer-events-none absolute inset-0 -z-0">
            <div className="bg-dot-grid absolute inset-0 opacity-60 [mask-image:radial-gradient(900px_circle_at_50%_-10%,black,transparent)]" />
            <div className="absolute left-1/2 top-[-60%] h-[480px] w-[900px] -translate-x-1/2 rounded-full bg-[radial-gradient(ellipse_at_center,rgba(11,99,222,0.3),transparent_65%)] blur-[70px]" />
          </div>

          <div className="card-body relative z-10 flex justify-center items-center py-16">
            <h2 className="font-medium tracking-tight text-4xl lg:text-6xl mt-4 sm:mt-1 text-center max-w-3xl mx-auto px-10 lg:px-0">
              Your Chrome extension idea{" "}
              <span className="bg-gradient-to-br from-[#4d94ff] via-primary to-[#0a4fb0] bg-clip-text text-transparent">
                deserves to ship
              </span>
            </h2>
            <p className="text-md lg:text-lg text-center text-zinc-400 mx-auto mb-8 pt-4 px-8">
              Stop overthinking. Start with payments, auth, and store submission
              already built. Get your extension earning.
            </p>

            <div className="flex flex-col justify-center items-center gap-y-3 w-full max-w-xs">
              <button
                className={`btn btn-ghost bg-primary text-white hover:bg-secondary px-8 py-3 rounded-full ring-1 ring-inset ring-white/15 text-base font-semibold transition-all duration-200 shadow-[0_12px_44px_-10px_rgba(11,99,222,0.7)] w-full active:scale-[0.98]`}
                onClick={() =>
                  handleCheckoutSession(
                    PRICING_ID_T1,
                    DISCOUNT_ID,
                    PRICING_NAME_T1,
                    "cta",
                  )
                }
              >
                Get Started, $149
              </button>
              <p className="text-zinc-400 text-sm flex items-center gap-x-1.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="shrink-0"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                30-day money-back guarantee
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default CTA;
